import React from 'react';
import { EyeIcon, EditIcon, TrashIcon, CheckIcon, GlobeIcon } from 'lucide-react';
export function CurrencyList({
  currencies,
  onSelectCurrency,
  onDeleteCurrency,
  locale
}) {
  return <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-17382">
      {currencies.length === 0 ? <div className="px-4 py-5 sm:p-6 text-center text-gray-500" data-id="element-17383">
          No currencies found. Add a new currency to get started.
        </div> : <table className="min-w-full divide-y divide-gray-200" data-id="element-17384">
          <thead className="bg-gray-50" data-id="element-17385">
            <tr data-id="element-17386">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17387">
                Code
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17388">
                Name
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17389">
                Symbol
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17390">
                Countries
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17391">
                Status
              </th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17392">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-17393">
            {currencies.map(currency => <tr key={currency.currencyId} onClick={() => onSelectCurrency(currency)} className="hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-17394">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17395">
                  <div className="flex items-center" data-id="element-17396">
                    <div className="text-sm font-medium text-indigo-600" data-id="element-17397">
                      {currency.code}
                    </div>
                    <span className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-17398">
                      {currency.numericCode}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17399">
                  <div className="text-sm text-gray-900" data-id="element-17400">{currency.name}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17401">
                  <div className="text-sm text-gray-900" data-id="element-17402">{currency.symbol}</div>
                </td>
                <td className="px-6 py-4" data-id="element-17403">
                  <div className="text-sm text-gray-900 flex items-center" data-id="element-17404">
                    <GlobeIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-17405" />
                    <span data-id="element-17406">
                      {currency.countries.length > 2 ? `${currency.countries[0]}, ${currency.countries[1]} +${currency.countries.length - 2} more` : currency.countries.join(', ')}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17407">
                  {currency.isDefault ? <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-17408">
                      <CheckIcon className="h-4 w-4 mr-1" data-id="element-17409" />
                      Default
                    </span> : <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-17410">
                      Active
                    </span>}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-17411">
                  <button onClick={e => {
              e.stopPropagation();
              onSelectCurrency(currency);
            }} className="text-green-600 hover:text-green-900 mr-3" title="View currency" data-id="element-17412">
                    <EyeIcon className="h-4 w-4" data-id="element-17413" />
                    <span className="sr-only" data-id="element-17414">View</span>
                  </button>
                  <button onClick={e => {
              e.stopPropagation();
              onSelectCurrency(currency);
            }} className="text-indigo-600 hover:text-indigo-900 mr-3" title="Edit currency" data-id="element-17415">
                    <EditIcon className="h-4 w-4" data-id="element-17416" />
                    <span className="sr-only" data-id="element-17417">Edit</span>
                  </button>
                  <button onClick={e => {
              e.stopPropagation();
              onDeleteCurrency(currency);
            }} className="text-red-600 hover:text-red-900 disabled:opacity-50 disabled:cursor-not-allowed" disabled={currency.isDefault} title={currency.isDefault ? 'Cannot delete default currency' : 'Delete currency'} data-id="element-17418">
                    <TrashIcon className="h-4 w-4" data-id="element-17419" />
                    <span className="sr-only" data-id="element-17420">Delete</span>
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>}
    </div>;
}